var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import i18n from "../../../strings/i18n";
import { DetailValueWrapper, DetailWrapper, TooltipDivContainer, TypeContainer, } from "./AccountDetail.styles";
import Tooltip from "../Tooltip/Tooltip";
var AccountDetail = function (_a) {
    var children = _a.children, className = _a.className, dataCy = _a.dataCy, detail = _a.detail;
    var value = detail.value, type = detail.type, toolTipText = detail.toolTipText;
    return (_jsxs(DetailWrapper, __assign({ className: className }, { children: [_jsx(DetailValueWrapper, __assign({ "data-cy": dataCy && "".concat(dataCy, ".value"), "data-testid": "detail-label-unavailable", as: "li" }, { children: value })), _jsx(TypeContainer, { children: _jsxs(TooltipDivContainer, __assign({ as: "li", "data-cy": dataCy && "".concat(dataCy, ".label"), "data-testid": "detail-label-small", className: "detail-label-vertical" }, { children: [i18n({ labels: type }), toolTipText ? (_jsx(Tooltip, { toolTipText: toolTipText, ariaLabel: "".concat(i18n({ labels: type }), " Information"), ariaDescribedBy: "tooltip-container-".concat(i18n({ labels: type }), "-information") })) : null] })) }), children] })));
};
export default AccountDetail;
//# sourceMappingURL=AccountDetail.js.map